export default __webpack_public_path__ + "static/media/create-new.f418d702.svg";